let tableQueryConfig = [
  // 资产负债表
  {
    version: 5.5,
    queryConfig: [
      {
        label: '纳税人识别号',
        selected: true,
        default: true,
      },
      {
        label: '纳税人名称',
        selected: true,
        default: true,
      },
      {
        label: '事业部',
        selected: false,
        default: false,
      },
      {
        label: '所属大区',
        selected: false,
        default: false,
      },
      {
        label: '管理城市',
        selected: false,
        default: false,
      },
      {
        label: '主管税局省（市）',
        selected: false,
        default: false,
      },
      {
        label: '数据来源',
        selected: false,
        default: false,
      },
      {
        label: '跟进人',
        selected: false,
        default: false,
      },
    ],
    table: [
      {
        label: '纳税人名称',
        selected: true,
        default: true,
      },
      {
        label: '纳税人识别号',
        selected: true,
        default: true,
      },
      {
        label: '数据来源',
        selected: true,
        default: true,
      },
      {
        label: '事业部',
        selected: false,
        default: false,
      },
      {
        label: '所属区域',
        selected: false,
        default: false,
      },
      {
        label: '管理城市',
        selected: false,
        default: false,
      },
      {
        label: '主管税局省（市）',
        selected: false,
        default: false,
      },
      {
        label: '期末_资产合计',
        selected: true,
        default: true,
      },
      {
        label: '期末_负债合计',
        selected: true,
        default: true,
      },
      {
        label: '期末_未分配利润',
        selected: true,
        default: true,
      },
      {
        label: '期末_所有者权益合计',
        selected: true,
        default: true,
      },
      {
        label: '年初_资产合计',
        selected: true,
        default: true,
      },
      {
        label: '年初_负债合计',
        selected: true,
        default: true,
      },
      {
        label: '年初_未分配利润',
        selected: true,
        default: true,
      },
      {
        label: '年初_所有者权益合计',
        selected: true,
        default: true,
      },
      {
        label: '财务报表报送否',
        selected: true,
        default: true,
      },
      {
        label: '是否开启申报',
        selected: true,
        default: true,
      },
      {
        label: '跟进人',
        selected: false,
        default: false,
      },
    ],
  },
  //利润表
  {
    version: 5.5,
    queryConfig: [
      {
        label: '纳税人识别号',
        selected: true,
        default: true,
      },
      {
        label: '纳税人名称',
        selected: true,
        default: true,
      },
      {
        label: '事业部',
        selected: false,
        default: false,
      },
      {
        label: '所属大区',
        selected: false,
        default: false,
      },
      {
        label: '管理城市',
        selected: false,
        default: false,
      },
      {
        label: '主管税局省（市）',
        selected: false,
        default: false,
      },
      {
        label: '数据来源',
        selected: false,
        default: false,
      },
      {
        label: '跟进人',
        selected: false,
        default: false,
      },
    ],
    table: [
      {
        label: '纳税人名称',
        selected: true,
        default: true,
      },
      {
        label: '纳税人识别号',
        selected: true,
        default: true,
      },
      {
        label: '数据来源',
        selected: true,
        default: true,
      },
      {
        label: '事业部',
        selected: false,
        default: false,
      },
      {
        label: '所属区域',
        selected: false,
        default: false,
      },
      {
        label: '管理城市',
        selected: false,
        default: false,
      },
      {
        label: '主管税局省（市）',
        selected: false,
        default: false,
      },
      {
        label: '本月_营业收入',
        selected: true,
        default: true,
      },
      {
        label: '本月_营业成本',
        selected: true,
        default: true,
      },
      {
        label: '本月_销售费用',
        selected: true,
        default: true,
      },
      {
        label: '本月_管理费用',
        selected: true,
        default: true,
      },
      {
        label: '本月_研究费用',
        selected: true,
        default: true,
      },
      {
        label: '本月_财务费用',
        selected: true,
        default: true,
      },
      {
        label: '本月_利润总额',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_营业收入',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_营业成本',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_销售费用',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_管理费用',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_研究费用',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_财务费用',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_利润总额',
        selected: true,
        default: true,
      },
      {
        label: '财务报表报送否',
        selected: true,
        default: true,
      },
      {
        label: '是否开启申报',
        selected: true,
        default: true,
      },
      {
        label: '跟进人',
        selected: false,
        default: false,
      },
    ],
  },
  //现金流量表
  {
    version: 5.5,
    queryConfig: [
      {
        label: '纳税人识别号',
        selected: true,
        default: true,
      },
      {
        label: '纳税人名称',
        selected: true,
        default: true,
      },
      {
        label: '事业部',
        selected: false,
        default: false,
      },
      {
        label: '所属大区',
        selected: false,
        default: false,
      },
      {
        label: '管理城市',
        selected: false,
        default: false,
      },
      {
        label: '主管税局省（市）',
        selected: false,
        default: false,
      },
      {
        label: '数据来源',
        selected: false,
        default: false,
      },
      {
        label: '跟进人',
        selected: false,
        default: false,
      },
    ],
    table: [
      {
        label: '纳税人名称',
        selected: true,
        default: true,
      },
      {
        label: '纳税人识别号',
        selected: true,
        default: true,
      },
      {
        label: '数据来源',
        selected: true,
        default: true,
      },
      {
        label: '事业部',
        selected: false,
        default: false,
      },
      {
        label: '所属区域',
        selected: false,
        default: false,
      },
      {
        label: '管理城市',
        selected: false,
        default: false,
      },
      {
        label: '主管税局省（市）',
        selected: false,
        default: false,
      },
      {
        label: '本年累计_经营活动产生的现金流量净额',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_投资活动产生的现金流量净额',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_筹资活动产生的现金流量净额',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_期初现金余额',
        selected: true,
        default: true,
      },
      {
        label: '本年累计_期末现金余额',
        selected: true,
        default: true,
      },
      {
        label: '本月_经营活动产生的现金流量净额',
        selected: true,
        default: true,
      },
      {
        label: '本月_投资活动产生的现金流量净额',
        selected: true,
        default: true,
      },
      {
        label: '本月_筹资活动产生的现金流量净额',
        selected: true,
        default: true,
      },
      {
        label: '本月_期初现金余额',
        selected: true,
        default: true,
      },
      {
        label: '本月_期末现金余额',
        selected: true,
        default: true,
      },
      {
        label: '财务报表报送否',
        selected: true,
        default: true,
      },
      {
        label: '是否开启申报',
        selected: true,
        default: true,
      },
      {
        label: '跟进人',
        selected: false,
        default: false,
      },
    ],
  },
];

export default tableQueryConfig;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/smallBusinessGuidelines/tableQueryConfig.js